import React from 'react';
import '../theme/pages/noParams.css';
import { IonPage, IonContent, IonImg, IonLabel } from '@ionic/react';

class NoParams extends React.Component {
  render() {
    return (
      <IonPage className="no-params">
        <div style={{ display: 'none' }}>{process.env.REACT_APP_BUILD_STAGE}</div>
        <IonContent>
          <IonImg className="greetly-logo" src="./assets/img/greetly_logo.png" alt="" />
          <IonLabel className="find-interface">Please see the kiosk to start a new session</IonLabel>
        </IonContent>
      </IonPage>
    );
  }
}

export default NoParams;
